/**
 * productCatalog.js — loads the normalized, versioned term-level product
 * catalog (generated from the workbook by scripts/import-product-catalog.mjs)
 * and scopes it for the recommendation engine.
 *
 * The forward-mortgage universe excludes HELOCs, reverse mortgages, second
 * liens, and "program feature" rows: those are adjacent pathways, surfaced
 * separately so they never contaminate first-mortgage ranking.
 */
import catalog from '../data/termProductCatalog.json' with { type: 'json' };

export const CATALOG_VERSION = catalog.catalogVersion;

/** Every normalized product row (all classes). */
export function allProducts() {
  return catalog.products;
}

/** The rankable universe: first-lien forward mortgages. */
export function forwardMortgageUniverse() {
  return catalog.products.filter(
    (p) =>
      p.productClass === 'first' &&
      p.lienPosition === 'first' &&
      ['fixed', 'arm', 'io'].includes(p.structure.kind)
  );
}

/** Adjacent (non-ranked) pathways: reverse mortgages, HELOCs, seconds. */
export function adjacentPathwayProducts() {
  return catalog.products.filter(
    (p) => p.productClass === 'reverse' || p.productClass === 'heloc' || p.productClass === 'second'
  );
}

export function productById(termProgramId) {
  return catalog.products.find((p) => p.termProgramId === termProgramId) || null;
}
